import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.2, 0.7, 0.2, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTitle({ eyebrow, title, intro, light = false, className = "" }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      {eyebrow && <p className={`eyebrow mb-3 ${light ? "!text-gold" : ""}`}>{eyebrow}</p>}
      <h2 className={`h2 ${light ? "!text-white" : ""}`}>{title}</h2>
      {intro && <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-white/80" : "text-neutral-600"}`}>{intro}</p>}
    </div>
  );
}

export function PageHero({ eyebrow, title, intro, image, testid = "page-hero" }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden bg-ink text-white">
      {image && (
        <img src={image} alt="" loading="eager" className="absolute inset-0 h-full w-full object-cover opacity-35" />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/30" />
      <div className="absolute inset-0 pagne-light" />
      <div className="absolute left-0 top-0 h-full w-1.5 bg-u" />
      <div className="container-x relative py-16 sm:py-24">
        {eyebrow && <p className="fade-up font-display text-sm font-semibold uppercase tracking-[0.25em] text-gold">{eyebrow}</p>}
        <h1 className="fade-up mt-3 max-w-4xl font-display text-4xl font-bold uppercase leading-none tracking-tight sm:text-5xl lg:text-6xl" style={{ animationDelay: ".1s" }}>
          {title}
        </h1>
        {intro && (
          <p className="fade-up mt-5 max-w-2xl text-base text-white/80 sm:text-lg" style={{ animationDelay: ".2s" }}>
            {intro}
          </p>
        )}
      </div>
    </section>
  );
}

export function IconCards({ items, cols = "lg:grid-cols-3", testid = "icon-cards" }) {
  return (
    <div data-testid={testid} className={`grid gap-4 sm:grid-cols-2 ${cols}`}>
      {items.map(({ icon: Icon, title, text }, i) => (
        <Reveal key={title} delay={Math.min(i * 0.05, 0.3)}>
          <div className="card group h-full p-6 transition-transform duration-300 hover:-translate-y-1">
            <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-u-soft text-u transition-colors group-hover:bg-u group-hover:text-white">
              <Icon className="h-6 w-6" aria-hidden="true" />
            </div>
            <h3 className="font-display text-xl font-semibold uppercase leading-tight text-ink">{title}</h3>
            {text && <p className="mt-2 text-neutral-600">{text}</p>}
          </div>
        </Reveal>
      ))}
    </div>
  );
}

export function Placeholder({ text, className = "" }) {
  if (!text) return null;
  const isPh = text.includes("[Texte à compléter");
  return (
    <p className={`whitespace-pre-line leading-relaxed ${isPh ? "rounded-md border border-dashed border-gold bg-gold/10 p-4 italic text-neutral-700" : ""} ${className}`}>
      {text}
    </p>
  );
}

export function Empty({ children, testid }) {
  return (
    <div data-testid={testid} className="card pagne p-10 text-center text-neutral-600">
      {children}
    </div>
  );
}
